__turbopack_context__.v({
  "contactModal": "PlasmicForgotPassword-module__i-W4ua__contactModal",
  "content": "PlasmicForgotPassword-module__i-W4ua__content",
  "desktop": "PlasmicForgotPassword-module__i-W4ua__desktop",
  "forgotPasswordForm__hVwb": "PlasmicForgotPassword-module__i-W4ua__forgotPasswordForm__hVwb",
  "forgotPasswordForm__t4KkE": "PlasmicForgotPassword-module__i-W4ua__forgotPasswordForm__t4KkE",
  "loginTroubleshootingModal": "PlasmicForgotPassword-module__i-W4ua__loginTroubleshootingModal",
  "mobile": "PlasmicForgotPassword-module__i-W4ua__mobile",
  "news___2C30P": "PlasmicForgotPassword-module__i-W4ua__news___2C30P",
  "news__vwqO": "PlasmicForgotPassword-module__i-W4ua__news__vwqO",
  "root": "PlasmicForgotPassword-module__i-W4ua__root",
});
